import React, { useState, useEffect } from 'react';

import { Dialog, Card, Collapse } from '@mui/material';
import { images, icons, markers } from "../../helpers/constants";
import { Trans, useTranslation } from "react-i18next";
import Button from '../Buttons/Button';
import { useIsMobile } from '../../helpers/customHooks';
import SegmentedControl from '../SegmentedControl/SegmentedControl';
import SafetyZoneMap from '../Map/SafetyZoneMap';
import { downloadPDF, fixDate } from '../../helpers/helperFunctions';
import toast from 'react-hot-toast';
import NewButton from '../Buttons/NewButton';


const AlarmCentralModal = ({ data, show, testInfo, postTest, onClose, type, centrals, onSave, sendTestAlarm }) => {
    const MOBILE = useIsMobile();
    const { t } = useTranslation();
    // const [show, setShow] = useState(props.show)
    const [centralName, setCentralName] = useState()
    const [errorText, setErrorText] = useState()
    const [selectedAlarmCentral, setSelectedAlarmCentral] = useState()
    const [alarmAdditional, setAlarmAdditional] = useState()
    const [testPage, setTestPage] = useState(1)
    // const [testInfo, setTestInfo] = useState(testInfo)
    const [positionAccepted, setPositionAccepted] = useState(false)
    const [activeContract, setActiveContract] = useState(false)
    const [acceptTestDone, setAcceptTestDone] = useState(false)
    const [lastTestDate, setLastTestDate] = useState()
    const [loadingTest, setLoadingTest] = useState(false)

    const centerInfo = data?.alarmcenter

    useEffect(() => {
        // if(props.testInfo){
        //     setTestInfo(testInfo ? props.testInfo : null)
        // }
        if(data){
            setLastTestDate(centerInfo?.installationtest)
            setSelectedAlarmCentral(centerInfo?.centerid ?? -1)
            setAlarmAdditional(centerInfo?.additionalinfo ?? "")
        }
    }, [data, show])

    const handleClose = () => {
        onClose()
        setTimeout(() => {
            resetData()
        }, 200);
      //  setShow(false)
    }

    const resetData = () => {
        setTestPage(1)
        setPositionAccepted(false)
        setActiveContract(false)
        setAcceptTestDone(false)
        setLastTestDate(null)
    }    

    const handleSave = (type) => {
        let innerData = {}
        let reset = false
        switch(type){
            case "central":
                reset = false
                innerData = {
                    deviceid: data.id,
                    alarmcenter: selectedAlarmCentral,
                }
                break;
            case "info_update":
                reset = false
                innerData = {
                    deviceid: data.id,
                    alarmcenter_additionalinfo: alarmAdditional
                }
                break;
            case "unlink_central":
                innerData = {
                    deviceid: data.id,
                    unlink_alarmcenter: true
                }
                setSelectedAlarmCentral(-1)
                break;
            default: innerData = {}
        }
        onSave(innerData, reset)
    }


    const handleChange = (type, e) => {
        switch(type){
            case "info":
                setCentralName(e.target.value)
            break;
            default: return
        }
        setErrorText("")
    }

    const sendTestAlarmFunc = async () => {
        setLoadingTest(true)
        const response = await sendTestAlarm()
        setLoadingTest(false)
        if(!response.data.error && response?.status !== 404){
            setTestPage(testPage+1)
        }else{
            toast.error("ERROR")
        }
    }

    const postTestFunc = () => {
        postTest()      
        setAcceptTestDone(false)
        setActiveContract(false)
        setPositionAccepted(false)
    }



    const centralContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        {/* <img src={icons.central} alt=""/> */}
                        <h3 className="">{t("settings.alarm_central")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("settings.alarm_central_sub")}</p>
                <div className="d-flex justify-content-betwen">


					<div className="select-wrap w-100">
						<select value={selectedAlarmCentral} onChange={(e) => setSelectedAlarmCentral(e.target.value)} className="bg-light-grey grey-blue form-control text-truncate p-3 rounded24">
                            <option value="">{t("settings.select")}</option>
							{centrals.map((central, index) => (
                                <option key={index} value={central.id}>{central.name}</option>
							))}
						</select>
					</div>


                    {/* <select onChange={(event) => setSelectedAlarmCentral(event.target.value)} value={selectedAlarmCentral} className="form-control bg-light-grey">
                        <option value="">{t("settings.select")}</option>
                        {centrals?.map((central, index) => (
                            <option key={index} value={central.id}>{central.name}</option>
                        ))}
                    </select> */}
                    {/* <Button onClick={() => downloadCentralData(selectedAlarmCentral)} icon={icons.download} notext={true} btnClass="btn-transparent bg-dark-grey ms-3" /> */}
                </div>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => handleClose()} className="bg-grey rounded24 w-100 dark-grey me-2 p-3 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave(type)} className={`bg-gradient rounded24 w-100 white-white ms-2 p-3 body bold`}>{t("settings.save")}</NewButton>
                </div>
            </div>
        )
    }

    const infoContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        {/* <img src={icons.central} alt=""/> */}
                        <h3 className="">{t("settings.additional_info")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue py-3">{t("settings.additional_info_sub")}</p>
                <p className="grey-blue pb-3">
                    <Trans
                        i18nKey="settings.alarm_central_sub_selected"
                        components={{
                        central: <span className="bold"/>,
                        }}
                        values={{
                        central: centerInfo?.centername,
                        }}
                    />
                </p>
                <textarea 
                    rows={3} 
                    placeholder={t("settings.additional_info_placeholder")} 
                    defaultValue={alarmAdditional} 
                    onChange={(event) => setAlarmAdditional(event.target.value)} 
                    className="pb-3 form-control text-area-boy bg-light-grey rounded24" 
                />
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => handleClose()} className="bg-grey rounded24 w-100 dark-grey me-2 p-3 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave("info_update")} className={`bg-gradient rounded24 w-100 white-white ms-2 p-3 body bold`}>{t("settings.save")}</NewButton>
                </div>
            </div>
        )
    }

    const installationTestContent = () => {
        if(lastTestDate !== null && lastTestDate !== false){
            setLastTestDate(null)
            setTestPage(4)
        }
        
        let testFailed = true
        const stoplight = (val) => {
            let icon = ""
            val === "green"
            ? icon = <img src={icons.stoplight_green} alt=""/>
            : val === "yellow"
            ? icon = <img src={icons.stoplight_yellow} alt=""/>
            : icon = <img src={icons.stoplight_red} alt=""/>
            return icon
        }

      
        if(testInfo?.positionstatus && testInfo?.serverstatus && testInfo?.dataplanstatus){
            testFailed = false
        }

        const positionTime = (status) => {

            if (!status) {
                return (
                    <div className="d-flex align-items-center">
                        {stoplight("red")}
                        <p className="ms-2 grey-blue">{t("settings.position_updated_red")}</p>
                    </div>
                );
            }
            return (
                <div className="d-flex align-items-center">
                    {stoplight("green")}
                    <p className="ms-2 grey-blue">{t("settings.position_updated_green")}</p>
                </div>
            );
        };

        const serverTime = (status) => {
            if (!status) {
                return (
                    <div className="d-flex align-items-center">
                        {stoplight("red")}
                        <p className="ms-2 grey-blue">{t("settings.server_updated_red")}</p>
                    </div>
                );
            }
            return (
                <div className="d-flex align-items-center">
                    {stoplight("green")}
                    <p className="ms-2 grey-blue">{t("settings.server_updated_green")}</p>
                </div>
            );
        };

        const dataplanStatus = (status) => {
            if(!status){
                return (
                    <div className="d-flex align-items-center">
                        {stoplight("red")}
                        <p className="ms-2 grey-blue">{t("settings.dataplan_false")}</p>
                    </div>
                ); 
            }
            return (
                <div className="d-flex align-items-center">
                    {stoplight("green")}
                    <p className="ms-2 grey-blue">{t("settings.dataplan_true")}</p>
                </div>
            );
        }


        const page1 = () => {
            return (
                <>
                    <p className="grey-blue py-3">{t("settings.installation_test_sub1")}</p>
                    <div className="d-flex mb-3">
                        {positionTime(testInfo?.positionstatus)}
                    </div>
                    <div className="d-flex mb-3">
                        {serverTime(testInfo?.serverstatus)}
                    </div>
                    <div className="d-flex">
                        {dataplanStatus(testInfo?.dataplanstatus)}
                    </div>
                    {!testInfo?.serverstatus && !testInfo?.positionstatus && !testInfo?.dataplanstatus
                        ? <p className="grey-blue pt-3">{t("settings.installation_test_error_all")}</p>
                        : !testInfo?.serverstatus || !testInfo?.positionstatus
                        ? <p className="grey-blue pt-3">{t("settings.installation_test_error_position")}</p>
                        : !testInfo?.dataplanstatus
                        ? <p className="grey-blue pt-3">{t("settings.installation_test_error_dataplan")}</p>
                        :
                        <>
                        <div className="mt-3">
                            <div className="rounded24 safety-map-border" style={{width: "auto", height: "200px"}}>
                            <SafetyZoneMap device={data} noFence={true}/>
                            </div>
                        </div>
                        <div className="d-flex  align-items-center mt-3">
                            <div className={`${positionAccepted ? "bg-checked" : "bg-grey"} size_25 rounded8 d-flex justify-content-center align-items-center p-1`} onClick={() => setPositionAccepted(!positionAccepted)}>
                                {positionAccepted && <img className="white-icon size_15" src={icons.check} alt={""} />}
                            </div>
                            <p className="ms-2 grey-blue">{t("settings.accept_position")}</p>
                        </div>

                        </>
                    }

                </>
            )
        }

        const page2 = () => {
            return(
                <>
                    <p className="grey-blue py-3">{t("settings.installation_test_p2_sub1")}</p>
                    <div className="d-flex align-items-center">
                        <div className={`${activeContract ? "bg-checked" : "bg-grey"} size_25 rounded8 d-flex justify-content-center align-items-center p-1`} onClick={() => setActiveContract(!activeContract)}>
                            {activeContract && <img className="white-icon size_15" src={icons.check} alt={""} />}
                        </div>
                        <p className="ms-2 grey-blue">{t("settings.active_contract_sub")}</p>
                    </div>
                </>
            )
        }

        const page3 = () => {
            return(
                <>
                    <p className="grey-blue py-3">{t("settings.installation_test_p3_sub1")}</p>
                    <div className="d-flex align-items-center">
                        <div className={`${acceptTestDone ? "bg-checked" : "bg-grey"} size_25 rounded8 d-flex justify-content-center align-items-center p-1`} onClick={() => setAcceptTestDone(!acceptTestDone)}>
                            {acceptTestDone && <img className="white-icon size_15" src={icons.check} alt={""} />}
                        </div>
                        <p className="ms-2 grey-blue">{t("settings.accept_test_done_sub")}</p>
                    </div>
                </>
            )
        }

        const page4 = () => {
            return(
                <>
                    <p className="grey-blue py-3">{t("settings.installation_test_p4_sub", {date: fixDate(centerInfo?.installationtest, true)})}</p>
                </>
            )
        }


        return (
            <div className={`${testInfo ? "p-3" : "d-none"}`}>
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        {/* <img src={icons.central} alt=""/> */}
                        <h3 className="">{t("settings.installation_test")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                {testPage === 1
                    ? page1()
                    : testPage === 2
                    ? page2()
                    : testPage === 3
                    ? page3()
                    : testPage === 4
                    ? page4()
                    : null
                }

                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => handleClose()} className="bg-grey rounded24 w-100 dark-grey me-2 p-3 body bold">{t("settings.cancel")}</NewButton>
                    {testPage === 1
                        ? 
                        <NewButton 
                            onClick={() => testFailed ? onClose() : setTestPage(testPage+1)}
                            className={`bg-gradient rounded24 w-100 white-white ms-2 p-3 body bold ${!testFailed && !positionAccepted ? "disabled" : ""}`}>
                                {testFailed ? t("settings.confirm") : t("settings.start_test")}
                        </NewButton>
                        : testPage === 2
                        ?  
                        <NewButton 
                            onClick={() => sendTestAlarmFunc()} 
                            className={`bg-gradient rounded24 w-100 white-white ms-2 p-3 body bold ${!activeContract || loadingTest ? "disabled" : ""}`}>
                                <span className={`${loadingTest ? "" : "d-none"} me-2 size_15 spinner-grow`}/>
                                {t("settings.send_test_alarm")}
                            </NewButton>
                        : testPage === 3
                        ? <NewButton 
                            onClick={() => postTestFunc()} 
                            className={`bg-gradient rounded24 w-100 white-white ms-2 p-3 body bold ${!acceptTestDone ? "disabled" : ""}`}>
                            {t("settings.confirm")}
                        </NewButton>
                        : testPage === 4
                        ? 
                        <NewButton 
                        onClick={() => setTestPage(1)} 
                            className={`bg-gradient rounded24 w-100 white-white ms-2 p-3 body bold`}>{t("settings.redo_test")}
                        </NewButton>
                        : null
                    }
                </div>

            </div>
        )
    }

    const unlinkContent = () => {
        return (
            <div className="p-3">
                <div className="d-flex flex-row justify-content-between align-items-center">
                    <div className='d-flex align-items-center'>
                        {/* <img src={icons.central} alt=""/> */}
                        <h3 className="">{t("settings.unlink_alarm")}</h3>
                    </div>
                    <img className="cursor-pointer" src={icons.close_gray} onClick={() => onClose()} alt="..." /> 
                </div>
                <p className="grey-blue pt-3">{t("settings.unlink_copy")}</p>
                <div className="d-flex flex-row justify-content-between align-items-center mt-4">
                    <NewButton onClick={() => handleClose()} className="bg-grey rounded24 w-100 dark-grey me-2 p-3 body bold">{t("settings.cancel")}</NewButton>
                    <NewButton onClick={() => handleSave("unlink_central")} className={`bg-red rounded24 w-100 white-white ms-2 p-3 body bold`}>{t("settings.confirm")}</NewButton>
                </div>
            </div>
        )
    }


    const typeRender = () => {
        switch(type){
            case "central": return centralContent()
            case "info": return infoContent()
            case "installation_test": return installationTestContent()
            case "unlink_central": return unlinkContent()
            default: return null
        }
    }


return(
    <>
    <Dialog fullWidth={MOBILE ? true : false} open={show} onClose={handleClose}>
        <Card className="settings-dialog d-flex flex-column scrollable-y">
            <div className="w-100 h-100 grey-blue">
                {typeRender()}
            </div>
        </Card>
    </Dialog>
    </>
)
}

export default AlarmCentralModal;